import React from 'react';
import Icon from '../../../components/AppIcon';
import { formatCurrency } from '../../../utils/currency';

const ExpenseStats = ({ stats, currency }) => {
  const statCards = [
    {
      label: 'Total Expenses',
      value: formatCurrency(stats?.total || 0),
      icon: 'DollarSign',
      color: 'primary',
      change: stats?.totalChange,
      changeType: stats?.totalChange >= 0 ? 'increase' : 'decrease'
    },
    {
      label: 'Pending Approval',
      value: stats?.pending || 0,
      icon: 'Clock',
      color: 'warning',
      subtext: formatCurrency(stats?.pendingAmount || 0)
    },
    {
      label: 'Approved',
      value: stats?.approved || 0,
      icon: 'CheckCircle',
      color: 'success',
      subtext: formatCurrency(stats?.approvedAmount || 0)
    },
    {
      label: 'Tax Deductible',
      value: formatCurrency(stats?.taxDeductible || 0),
      icon: 'Receipt',
      color: 'accent',
      subtext: `${stats?.taxDeductibleCount || 0} expenses`
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-6">
      {statCards?.map((stat, index) => (
        <div
          key={index}
          className="bg-card rounded-lg shadow-sm border border-border p-4 md:p-6 hover-lift transition-smooth"
        >
          <div className="flex items-start justify-between mb-3">
            <div className={`w-10 h-10 md:w-12 md:h-12 rounded-md flex items-center justify-center bg-${stat?.color}/10`}>
              <Icon name={stat?.icon} size={20} color={`var(--color-${stat?.color})`} />
            </div>
            {stat?.change !== undefined && (
              <div className={`flex items-center gap-1 px-2 py-1 rounded-md ${
                stat?.changeType === 'increase' ?'bg-success/10 text-success' :'bg-error/10 text-error'
              }`}>
                <Icon 
                  name={stat?.changeType === 'increase' ? 'TrendingUp' : 'TrendingDown'} 
                  size={14} 
                />
                <span className="caption font-medium">{Math.abs(stat?.change)}%</span>
              </div>
            )}
          </div>
          <div>
            <p className="caption text-muted-foreground mb-1">{stat?.label}</p>
            <p className="font-heading font-semibold text-xl md:text-2xl text-foreground mb-1">
              {stat?.value}
            </p>
            {stat?.subtext && (
              <p className="caption text-muted-foreground">{stat?.subtext}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ExpenseStats;